import React from 'react'
import { NO_IMAGE_SOURCE } from './constants'

export default function RentalListItem({ rental, rentalListVersion }) {
  const { arrangements, base_rate, image, information, name, rooms } = rental

  return (
    <>
      <div className='rental-image'>
        <img
          src={ image ? image : NO_IMAGE_SOURCE }
          loading='lazy'
        />
      </div>

      { rentalListVersion == 'version_two' &&
        <div className='rental-bottom-title'>
          { name }
        </div>
      }

      <div className='rental-details'>
        <div className='rental-name'>
          { name }
        </div>

        <div className='rental-base-rate'>
          { base_rate && base_rate.price_per_night }
        </div>

        <div className='bottom-rental-details'>
          <div className='rental-amenities'>
            { information.area &&
              <div className='flex-box'>
                <div>
                  <i className='fal fa-vector-square'/>
                  { information.area }
                </div>

                { information.available_units > 0 &&
                  <div style={{ marginLeft: 10 }}>
                    <i className='fal fa-door-open'/>
                    { information.available_units }
                  </div>
                }
              </div>
            }

            { arrangements.length > 0 &&
              <div>
                <i className='fad fa-bed-alt'/>
                { arrangements[0].quantity } { arrangements[0].presentation }
              </div>
            }

            { rooms.length > 0 &&
              <div>
                <i className='far fa-bed'/>
                { rooms[0].quantity } { rooms[0].presentation }
              </div>
            }
          </div>
        </div>
      </div>
    </>
  )
}
